import { FC } from 'react';
import clsx from 'clsx';
import './styles.scss';
import { TItem } from '../types';

interface AlphabetItemProps {
	item: TItem;
	alphabetSymbol: string;
	hideSymbol: boolean;
	onSelect?: (item: TItem) => void;
}

export const AlphabetItem: FC<AlphabetItemProps> = ({
	item,
	alphabetSymbol,
	hideSymbol = false,
	onSelect,
}) => {
	const selectHandler = () => onSelect?.({ ...item });

	const alphabetClassNames = clsx({
		'alphabetical-items-list__alphabet': true,
		'alphabetical-items-list__alphabet--hidden': hideSymbol,
	});

	return (
		<div
			className="alphabetical-items-list__item-wrapper"
			role="alphabet-item"
			onClick={selectHandler}
		>
			<div key={alphabetSymbol} className={alphabetClassNames}>
				{alphabetSymbol}
			</div>
			<div key={item.id} className="alphabetical-items-list__name">
				{item.name}
			</div>
		</div>
	);
};
